"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProtectedAttribute = exports.TokenTraits = exports.TokenMetadata = exports.TokenStatus = void 0;
var TokenStatus;
(function (TokenStatus) {
    TokenStatus["MINTED"] = "MINTED";
    TokenStatus["BURNED"] = "BURNED";
})(TokenStatus || (exports.TokenStatus = TokenStatus = {}));
var TokenMetadata;
(function (TokenMetadata) {
    TokenMetadata["TEMPLATE_ID"] = "TEMPLATE_ID";
    TokenMetadata["LEVEL"] = "LEVEL";
    TokenMetadata["RARITY"] = "RARITY";
    TokenMetadata["TRAITS"] = "TRAITS";
    TokenMetadata["GENES"] = "GENES";
    TokenMetadata["ROUND"] = "ROUND";
    TokenMetadata["NUMBERS"] = "NUMBERS";
    TokenMetadata["PRIZE"] = "PRIZE";
})(TokenMetadata || (exports.TokenMetadata = TokenMetadata = {}));
var TokenTraits;
(function (TokenTraits) {
    TokenTraits["CLOTHES"] = "CLOTHES";
    TokenTraits["EYES"] = "EYES";
    TokenTraits["MOUTH"] = "MOUTH";
})(TokenTraits || (exports.TokenTraits = TokenTraits = {}));
var ProtectedAttribute;
(function (ProtectedAttribute) {
    ProtectedAttribute["TEMPLATE_ID"] = "TEMPLATE_ID";
    ProtectedAttribute["RARITY"] = "RARITY";
    ProtectedAttribute["TRAITS"] = "TRAITS";
    ProtectedAttribute["GENES"] = "GENES";
})(ProtectedAttribute || (exports.ProtectedAttribute = ProtectedAttribute = {}));
//# sourceMappingURL=token.js.map